import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import useStore from "../../store";
import { useNavigate } from "react-router-dom";
import ModalBasic from "./ModalBasic.jsx";

// 회원 탈퇴 모달창 컴포넌트
const ModalUserWithdrawal = ({ isOpen, onClose }) => {
  const { withdrawUser } = useStore();
  const navigate = useNavigate();
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // ESC 키 누르면 모달 닫히도록 설정
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleWithdraw = async () => {
    const success = await withdrawUser();
    if (success) {
      // 탈퇴 성공 시 처리
      onClose();
      navigate("/"); // 로그인 페이지로 리다이렉트
    } else {
      // 실패 시 처리
      alert("회원탈퇴에 실패했습니다. 다시 시도해주세요.");
    }
  };


  return (
    <ModalBasic
      isOpen={isOpen}
      onClose={onClose}
      width={window.innerWidth > 430 ? "400px" : "312px"}
      height={window.innerWidth > 430 ? "168px" : "144px"}
      padding={window.innerWidth > 430 ? "24px" : "21px"}>
      <TextWrapper>
        <Header>회원 탈퇴</Header>
        <Content>
          정말로 탈퇴하시겠습니까? 모든 데이터가 삭제되며 복구할 수 없습니다.
        </Content>
      </TextWrapper>

      <ButtonWrapper>
        <ButtonStyles type="cancel" onClick={onClose}>
          취소
        </ButtonStyles>
        <ButtonStyles type="withdraw" onClick={handleWithdraw}>
          탈퇴하기
        </ButtonStyles>
      </ButtonWrapper>
    </ModalBasic>
  );
};

const Header = styled.div`
  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: inline;

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;

const Content = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-top: 12px;

  @media (max-width: 430px) {
    font-size: 14px;
    line-height: 24px;
    margin-top: 10px;
    margin-right: 27px;
  }
`;

const TextWrapper = styled.div`
  margin-top: 8px;
  margin-left: 8px;
  margin-right: 7px;

  @media (max-width: 430px) {
    margin-top: 5px;
    margin-left: 3px;
    margin-right: 0px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-right: 8px;
  margin-top: 18px;

  @media (max-width: 430px) {
    margin-top: 16px;
    margin-right: 3px;
  }
`;

const ButtonStyles = styled.div`
  width: 70px;
  height: 40px;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  background: ${(props) => {
    if (props.type === "withdraw") return "#ff5252";
    if (props.type === "cancel") return "#F2F2F2";
    return "#000";
  }};
  color: ${(props) => (props.type === "cancel" ? "#000" : "#FFF")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;

export default ModalUserWithdrawal;
